export default function RailSearchParamsFactory(
    railsUtils,
    userService
) {
    'ngInject';
        const PAGINATION_STEP = 20;

        function Params(module) {
            this.module = module;
            this.RailTicketSearchSegments = [{_isArrivalTime: false}, {_isArrivalTime: false}, {}, {}];
            //pay attention to 'Travelers' -  mistake from backend side
            this.Travelers = {
                Adult: {value: 1},
                Child: {value: 0},
            };
            this.ReturnOrSingleJourney = '';
            this.OutwardArrivalDepartureFlag = '';
            this.ReturnArrivalDepartureFlag = '';
            this.ArrivingOrDeparting = '';
            this.SegmentFilterData = [];
            this.RailCards = [];
            this.TrainlineRailCards = [];
            this.GoViaOrAvoid = null;
            this.GoViaOrAvoidRailStation = '';

            this.min = 0;
            this.max = 20;

            this.IncludeNearbyRailStations = false;
            this.DirectRailsOnly = false;
            this.CharityFaresOnly = false;
            this.IncludeEuroStar = true;
            this.railCardsCount = 0;
            this.chkRailCards = false;
            this.isOpenReturn = false;
            this.Id = '';
            this.TravelCards = null;
        }

        Params.prototype.recreate = function(search, extendedSearch, options, type) { // eslint-disable-line
            let arrivalRailStation;
            let departureRailStation;
            const keys = {
                trains: 'All Train Stations',
                flights: 'All airports',
            };

            this.ReturnOrSingleJourney = search.ReturnOrSingle;
            this.OutwardArrivalDepartureFlag = search.OutwardArrivalDepartureFlag;
            this.ReturnArrivalDepartureFlag = search.ReturnArrivalDepartureFlag;
            this.isOpenReturn = search.IsOpenReturn;
            this.Id = search.SearchId;
            this.SearchId = search.SearchId;
            this.DirectRailsOnly = search.DirectRailsOnly;

            if (search.GoViaOrAvoid !== null && search.GoViaOrAvoid !== 'None' && search.GoViaOrAvoid !== '') {
                this.GoViaOrAvoid = options.ukRailGoViaAvoidOptions.filter((item) => item.Text === search.GoViaOrAvoid)[0];
            } else {
                this.GoViaOrAvoid = options.ukRailGoViaAvoidOptions[0];
            }
            this.GoViaOrAvoidRailStation = search.GoViaOrAvoidDisplayString;

            for (let i = 0; i < search.SearchSegments.length; i++) {
                arrivalRailStation = search.SearchSegments[i].IsArrivalPointName
                    ? keys[this.module]
                    : search.SearchSegments[i].ArrivalPointName;

                departureRailStation = search.SearchSegments[i].IsDeparturePointName
                    ? keys[this.module]
                    : search.SearchSegments[i].DeparturePointName;

                this.RailTicketSearchSegments[i]._arrival = {
                    DisplayString: search.SearchSegments[i].ArrivalDisplayString,
                    airport: arrivalRailStation,
                    name: search.SearchSegments[i].ArrivalCity
                    + ', ' + search.SearchSegments[i].ArrivalCountryCode,
                    Code: search.SearchSegments[i].ArrivalPointCode,
                    IsCity: search.SearchSegments[i].IsArrivalPointCity,
                };

                this.RailTicketSearchSegments[i]._departure = {
                    DisplayString: search.SearchSegments[i].DepartureDisplayString,
                    airport: departureRailStation,
                    name: search.SearchSegments[i].DepartureCity
                    + ', ' + search.SearchSegments[i].DepartureCountryCode,
                    Code: search.SearchSegments[i].DeparturePointCode,
                    IsCity: search.SearchSegments[i].IsDeparturePointCity,
                };

                if (angular.isDefined(this.RailTicketSearchSegments[i].DHour) && angular.isDefined(this.RailTicketSearchSegments[i].DMinutes)) {
                    this.RailTicketSearchSegments[i].DHour.Text = search.SearchSegments[i].DepartureHour;
                    this.RailTicketSearchSegments[i].DHour.Value = search.SearchSegments[i].DepartureHour;
                    this.RailTicketSearchSegments[i].DMinutes.Text = search.SearchSegments[i].DepartureMinute;
                    this.RailTicketSearchSegments[i].DMinutes.Value = search.SearchSegments[i].DepartureMinute;
                }

                if (angular.isDefined(this.RailTicketSearchSegments[i].RHour) && angular.isDefined(this.RailTicketSearchSegments[i].RMinutes)) {
                    this.RailTicketSearchSegments[i].RHour.Text = search.SearchSegments[i].DepartureHour;
                    this.RailTicketSearchSegments[i].RHour.Value = search.SearchSegments[i].DepartureHour;
                    this.RailTicketSearchSegments[i].RMinutes.Text = search.SearchSegments[i].DepartureMinute;
                    this.RailTicketSearchSegments[i].RMinutes.Value = search.SearchSegments[i].DepartureMinute;
                }
                this.RailTicketSearchSegments[i]._date
                    = moment(search.SearchSegments[i].DepartureDate, 'YYYY-MM-DD')
                        .format(userService.getRegionalSettings().dateFormat);
                this.RailTicketSearchSegments[0]._isArrivalTime = this.OutwardArrivalDepartureFlag === 'A';
                this.RailTicketSearchSegments[1]._isArrivalTime = this.ReturnArrivalDepartureFlag === 'A';
            }

            this.IncludeEuroStar = extendedSearch.IncludeEuroStar;
            this.IncludeNearbyRailStations = extendedSearch.IncludeNearbyRailStations;
            this.CharityFaresOnly = extendedSearch.CharityFaresOnly;
            this.DirectRailsOnly = extendedSearch.DirectRailsOnly;
            this.PreferredRailCode = search.PreferredRailCode;
            this.Travelers.Adult = _.findWhere(options.adults, {value: '' + extendedSearch.Travelers.Adult});
            this.Travelers.Child = _.findWhere(options.children, {value: '' + extendedSearch.Travelers.Child});
            this.flightType = type;

            if (this.flightType === 'roundtrip') {
                if (extendedSearch.IsOpenReturn) {
                    this.ReturnOrSingleJourney = 'O';
                } else {
                    this.ReturnOrSingleJourney = 'R';
                }
            } else {
                this.ReturnOrSingleJourney = 'S';
            }
        };

        Params.prototype.getSearchRequestParams = function getSearchRequestParams(arrivalFlags) { // eslint-disable-line
            const request = angular.copy(this);

            request.Id = '';
            request.Travelers.Adult = request.Travelers.Adult.value;

            request.Travelers.Child = {value: 0};
            request.Travelers.Child = request.Travelers.Child.value;
            request.TotalPassengerCount
                = +request.Travelers.Adult + +request.Travelers.Child;

            request.RailTicketSearchSegments[0]._isArrival = arrivalFlags && arrivalFlags.outbound;

            request.MaxJourney = 4;
            request.IsAvoidTube = false;

            request.RailCards = getProcessedRailCards(this.ukRailCards, this.ukRailCardNumbers);
            if (this.passengersRailcards) {
                request.TrainlineRailCards = this.passengersRailcards.map((passengerCards) =>
                    passengerCards.cards.map((card) =>
                        ({Code: card.type.Code, Number: card.number})
                    )
                );
            }
            delete request.passengersRailcards;
            delete request.module;
            delete request.adultCount;
            delete request.chkRailCards;
            delete request.railCardsCount;

            request.RailTicketSearchSegments[0].DepartureHour
                        = angular.copy(request.RailTicketSearchSegments[0].DHour.Text);
            request.RailTicketSearchSegments[0].DepartureMinute
                        = angular.copy(request.RailTicketSearchSegments[0].DMinutes.Text);

            switch (this.flightType) {
                case 'oneway':
                    request.OutwardArrivalDepartureFlag = (request.RailTicketSearchSegments[0]._isArrivalTime ? 'A' : 'D');
                    request.RailTicketSearchSegments.length = 1;
                    request.RailTicketSearchSegments[0]._isArrival = arrivalFlags && arrivalFlags.outbound;
                    request.ReturnOrSingleJourney = 'S';
                    this.ReturnOrSingleJourney = 'S';
                    this.OutwardArrivalDepartureFlag = request.OutwardArrivalDepartureFlag;
                    break;
                case 'roundtrip':
                    request.OutwardArrivalDepartureFlag = (request.RailTicketSearchSegments[0]._isArrivalTime ? 'A' : 'D');
                    request.ReturnArrivalDepartureFlag = (request.RailTicketSearchSegments[1]._isArrivalTime ? 'A' : 'D');

                    this.OutwardArrivalDepartureFlag = (request.RailTicketSearchSegments[0]._isArrivalTime ? 'A' : 'D');
                    this.ReturnArrivalDepartureFlag = (request.RailTicketSearchSegments[1]._isArrivalTime ? 'A' : 'D');

                    if (this.isOpenReturn) {
                        request.ReturnOrSingleJourney = 'O';
                        request.RailTicketSearchSegments.length = 1;
                        this.ReturnOrSingleJourney = 'O';
                    } else {
                        request.ReturnOrSingleJourney = 'R';
                        this.ReturnOrSingleJourney = 'R';

                        request.RailTicketSearchSegments.length = 2;
                        request.RailTicketSearchSegments[1]._departure
                        = angular.copy(request.RailTicketSearchSegments[0]._arrival);
                        request.RailTicketSearchSegments[1]._arrival
                            = angular.copy(request.RailTicketSearchSegments[0]._departure);
                        request.RailTicketSearchSegments[1]._isArrival = arrivalFlags && arrivalFlags.inbound;
                        request.RailTicketSearchSegments[1].DepartureHour
                            = angular.copy(request.RailTicketSearchSegments[1].RHour.Text);
                        request.RailTicketSearchSegments[1].DepartureMinute
                                    = angular.copy(request.RailTicketSearchSegments[1].RMinutes.Text);
                    }
                    break;
                case 'multitrip':

                    /**
                     * Remove unused segments in multitrip
                     */
                    break;
                default:
                    break;
            }

            _.forEach(request.RailTicketSearchSegments, function(segment) {
                    segment.DepartureRailStationCode = segment._departure ? segment._departure.Code : null;
                    segment.ArrivalRailStationCode = segment._arrival ? segment._arrival.Code : null;
                    segment.DepartureDate = moment(segment._date, userService.getRegionalSettings().dateFormat).format('YYYY-MM-DD');
                    segment.DepartureDayTime = segment._time.value;
                    segment.IsDepartureCity = segment._departure ? segment._departure.IsCity : null;
                    segment.IsArrivalCity = segment._arrival ? segment._arrival.IsCity : null;
                    segment.DayTimeFilterSource = (segment._isArrival) ? 1 : 0;

                    /**
                      * Remove synthetic fields
                      */
                    delete segment._departure;
                    delete segment._arrival;
                    delete segment._date;
                    delete segment._time;
                    delete segment._required;
                    delete segment._isArrival;
                    delete segment._isArrivalTime;
                });

            function getProcessedRailCards(railCards, railCardNumbers) {
                const processedRailCards = [];
                railCards.forEach((item, idx) => {
                    const railCardNumber = railCardNumbers[idx] && railCardNumbers[idx].value;
                    if (item.Code && railCardNumber) {
                        processedRailCards.push({
                            RailCardNum: railCardNumbers[idx].value,
                            RailCardName: item.Code,
                        });
                    }
                });
                return processedRailCards;
            }

            return request;
        };

        Params.prototype.resetPagination = function resetPagination() {
            this.min = 0;
            this.max = 20;
        };

        Params.prototype.adjustPaginationParams = function adjustPaginationParams(totalResults) {
            if ((totalResults - this.max) >= PAGINATION_STEP) {
                this.min = this.max;
                this.max = this.max + PAGINATION_STEP;
            } else {
                this.min = this.max;
                this.max = totalResults;
            }
        };

        return Params;
    }



// WEBPACK FOOTER //
// ./src/app/modules/base/services/railSearchParams.js